
import React, { createContext, useState } from "react";
import Proptypes from 'prop-types';

const FeedbackContext = createContext();

const FeedbackProvider = ({ children }) => {
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const contextValue = {
    showErrorAlert, setShowErrorAlert,
    isLoading, setIsLoading
  };

  return (
    <FeedbackContext.Provider value={contextValue}>
      {children}
    </FeedbackContext.Provider>
  );
};

FeedbackProvider.propTypes = {
  children: Proptypes.element
}

export { FeedbackContext as default, FeedbackProvider };

